import {
  returnOrThrow,
  BOOKINGS,
  postWrapper,
  getWrapper,
  patchWrapper,
  putWrapper,
} from './util';

export const flashBooking = async (data) => {
  const resJSON = await postWrapper(BOOKINGS, data);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const getBookings = async (data) => {
  const resJSON = await getWrapper(
    `${BOOKINGS}?toAirport=${data.toAirport}&fromAirport=${data.fromAirport}&airline=${data?.airline}&departureFrom=${data?.departureFrom}&departureTo=${data?.departureTo}&status=${data?.status}&bookingFrom=${data?.bookingFrom}&bookingTo=${data?.bookingTo}`
  );
  const result = await returnOrThrow(resJSON);
  return result;
};

export const bookingDetail = async (id) => {
  const resJSON = await getWrapper(`${BOOKINGS}/${id}`);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const cancelBooking = async (id) => {
  const resJSON = await patchWrapper(`${BOOKINGS}/${id}/cancel`);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const updateBooking = async (id, data) => {
  const resJSON = await putWrapper(`${BOOKINGS}/${id}`, data);
  const result = await returnOrThrow(resJSON);
  return result;
};
